import { IApp } from '../types/app';

export const loadApp = (): IApp => ({
    configuredExpanded: true,
    byodExpanded: true,
    webhookExpanded: true,
})



// WEBPACK FOOTER //
// ./src/sub-projects/codat/services/app.ts